// Constanta
import { BASE_URL } from "constant";
import privateFetch, { privateFetchFormData } from 'PrivateFetch';
export const INITIAL_STATE = { status: '', loading: false, data: [], error: false, success: false }

export const GET_DATA_HEWAN_LOADING = 'GET_DATA_HEWAN_LOADING';
export const GET_DATA_HEWAN_SUCCESS = 'GET_DATA_HEWAN_SUCCESS';
export const GET_DATA_HEWAN_ERROR = 'GET_DATA_HEWAN_ERROR';

export const SAVE_DATA_HEWAN_LOADING = 'SAVE_DATA_HEWAN_LOADING';
export const SAVE_DATA_HEWAN_SUCCESS = 'SAVE_DATA_HEWAN_SUCCESS';
export const SAVE_DATA_HEWAN_ERROR = 'SAVE_DATA_HEWAN_ERROR';

export const UPDATE_DATA_HEWAN_LOADING = 'UPDATE_DATA_HEWAN_LOADING';
export const UPDATE_DATA_HEWAN_SUCCESS = 'UPDATE_DATA_HEWAN_SUCCESS';
export const UPDATE_DATA_HEWAN_ERROR = 'UPDATE_DATA_HEWAN_ERROR';

export const DELETE_DATA_HEWAN_LOADING = 'DELETE_DATA_HEWAN_LOADING';
export const DELETE_DATA_HEWAN_SUCCESS = 'DELETE_DATA_HEWAN_SUCCESS';
export const DELETE_DATA_HEWAN_ERROR = 'DELETE_DATA_HEWAN_ERROR';

export const IMPORT_DATA_HEWAN_LOADING = 'IMPORT_DATA_HEWAN_LOADING';
export const IMPORT_DATA_HEWAN_SUCCESS = 'IMPORT_DATA_HEWAN_SUCCESS';
export const IMPORT_DATA_HEWAN_ERROR = 'IMPORT_DATA_HEWAN_ERROR';



// function dispatch
const getDataHewanLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: GET_DATA_HEWAN_LOADING,
        loading: bool
    }
}

const getDataHewanSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: GET_DATA_HEWAN_SUCCESS,
        success: bool,
        data: data
    }
}

const getDataHewanError = bool => {
    return {
        ...INITIAL_STATE,
        type: GET_DATA_HEWAN_ERROR,
        error: bool
    }
}

const saveDataHewanLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: SAVE_DATA_HEWAN_LOADING,
        loading: bool
    }
}

const saveDataHewanSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: SAVE_DATA_HEWAN_SUCCESS,
        success: bool,
        data: data
    }
}

const saveDataHewanError = bool => {
    return {
        ...INITIAL_STATE,
        type: SAVE_DATA_HEWAN_ERROR,
        error: bool
    }
}

const updateDataHewanLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: UPDATE_DATA_HEWAN_LOADING,
        loading: bool
    }
}

const updateDataHewanSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: UPDATE_DATA_HEWAN_SUCCESS,
        success: bool,
        data: data
    }
}

const updateDataHewanError = bool => {
    return {
        ...INITIAL_STATE,
        type: UPDATE_DATA_HEWAN_ERROR,
        error: bool
    }
}

const deleteDataHewanLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: DELETE_DATA_HEWAN_LOADING,
        loading: bool
    }
}

const deleteDataHewanSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DELETE_DATA_HEWAN_SUCCESS,
        success: bool,
        data: data
    }
}

const deleteDataHewanError = bool => {
    return {
        ...INITIAL_STATE,
        type: DELETE_DATA_HEWAN_ERROR,
        error: bool
    }
}

const importDataHewanLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: IMPORT_DATA_HEWAN_LOADING,
        loading: bool
    }
}

const importDataHewanSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: IMPORT_DATA_HEWAN_SUCCESS,
        success: bool,
        data: data
    }
}

const importDataHewanError = bool => {
    return {
        ...INITIAL_STATE,
        type: IMPORT_DATA_HEWAN_ERROR,
        error: bool
    }
}

// function API
export function getDataHewan(data) {
    let url = BASE_URL + 'hewan/page'
    return privateFetch(getDataHewanSuccess, getDataHewanError, getDataHewanLoading, 'POST', url, data);
}

export function saveDataHewan(data) {
    let url = BASE_URL + 'hewan/save'
    return privateFetch(saveDataHewanSuccess, saveDataHewanError, saveDataHewanLoading, 'POST', url, data);
}

export function updateDataHewan(data) {
    let url = BASE_URL + 'hewan/update'
    return privateFetch(updateDataHewanSuccess, updateDataHewanError, updateDataHewanLoading, 'POST', url, data);
}

export function deleteDataHewan(data) {
    let url = BASE_URL + 'hewan/delete'
    return privateFetch(deleteDataHewanSuccess, deleteDataHewanError, deleteDataHewanLoading, 'POST', url, data);
}

export function importDataHewan(data) {
    let url = BASE_URL + 'hewan/import'
    return privateFetchFormData(importDataHewanSuccess, importDataHewanError, importDataHewanLoading, 'POST', url, data);
}